import BaseClass from "../util/BaseClass";
import ReferenceLayer from "../aiim/base/ReferenceLayer";
import UserSettings from "../aiim/base/UserSettings";

export default class Session extends BaseClass {

  cfgState = {};
  cfServiceDescription;
  networkServiceInfo;
  referenceLayer;
  selectedTravelModeID;
  startInConfiguratorMode;
  startupToast;
  userSettings;

  constructor(props) {
    super(props);
    this.referenceLayer = new ReferenceLayer();
    this.userSettings = new UserSettings();
  }

  viewsReloading() {
    this.startupToast = null;
    this.referenceLayer = new ReferenceLayer();
  }

}
